import { configureStore } from "@reduxjs/toolkit";
import UserReducer from "./features/userSlice";

export const store = configureStore({
  reducer: {
    User: UserReducer,
  },
  devTools: process.env.NODE_ENV === "development",
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat([
      //   AuthApi.middleware,
    ]),
});
